module.exports = __webpack_public_path__ + "static/media/wedding.5ec61a37.png";